import React from 'react';

import { dataHooks } from '../../constants';
import { LegendSize } from '../../FieldSet.types';

import { st, classes } from './Asterisk.st.css';

const Asterisk = ({ labelSize }: { labelSize: LegendSize }) => (
  <div
    aria-hidden
    data-hook={dataHooks.asterisk}
    className={st(classes.root, {
      labelSize,
    })}
    children="*"
  />
);

export default Asterisk;
